export default __webpack_public_path__ + "images/oneReportWhite.73b68de9d168668bf56ba7a77e05a68a.svg";